import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import Draft from './draft';
class Agreement extends Component {
  constructor(){
    super();
    this.state={
      accept:false,  
      hasError:false,
      programs:{isSelected:false,programName:''}
    }
    this.programStatus=this.programStatus.bind(this);
  }
  componentWillMount=()=>{
    this.programStatus();
  }
  programStatus=()=>{
    let _appData=this.props.lunchObj;
    let programs=[];
    let isSelected=false
    _appData.assistancePrograms.map((program)=>{
      if(program.isApplicable){
        isSelected=true;
        programs.push(program.accronym)
      }
    })
    let _programs={isSelected:isSelected,programName:programs.join(',')}
   this.setState({programs:_programs});
 }
  
    render(){
        return(
          <div>
        <div className="row">
          <div className="col-xs-12">
              <div className="lowerPartTitle">
                <h4 style={{textTransform:'none'}}><Trans>Legal Statements</Trans></h4>
                <p><Trans>Almost done! Please read and acknowledge the following legal statements</Trans>.</p>
                <h4 style={{textTransform:'none'}}><Trans>Use of Information Statement</Trans></h4>
                <p><Trans>The Richard B</Trans>. <Trans>Russell National School Lunch Act requires the information on this application</Trans>. <Trans>You do not have to give the information, but if you do not, we cannot approve your child for free or reduced price meals</Trans>. <Trans>You must include the last four digits of the social security number of the adult household member who signs the application</Trans>. <Trans>The last four digits of the social security number is not required when you apply on behalf of a foster child or you list a Supplemental Nutrition Assistance Program (SNAP), Temporary Assistance for Needy Families (TANF) Program or Food Distribution Program on Indian Reservations (FDPIR) case number or other FDPIR identifier for your child or when you indicate that the adult household member signing the application does not have a social security number</Trans>. <Trans>We will use your information to determine if your child is eligible for free or reduced price meals, and for administration and enforcement of the lunch and breakfast programs</Trans>.</p>
                <p><Trans>We may share your eligibility information with education, health, and nutrition programs to help them evaluate, fund, or determine benefits for their programs, auditors for program reviews, and law enforcement officials to help them look into violations of program rules</Trans>.</p>
                <h4 style={{textTransform:'none'}}><Trans>USDA Non-Discrimination Statement</Trans></h4>
                <p><Trans>In accordance with federal civil rights law and</Trans> U.S. <Trans>Department of Agriculture (USDA) civil rights regulations and policies, this institution is prohibited from discriminating on the basis of race, color, national origin, sex (including gender identity and sexual orientation), disability, age, or reprisal or retaliation for prior civil rights activity</Trans>.</p>
                <p><Trans>Program information may be made available in languages other than English</Trans>. <Trans>Persons with disabilities who require alternative means of communication to obtain program information (e.g., Braille, large print, audiotape, American Sign Language), should contact the responsible state or local agency that administers the program or USDA’s TARGET Center at (202) 720-2600 (voice and TTY) or contact USDA through the Federal Relay Service at (800) 877-8339</Trans>.</p>
                <p><Trans>To file a program discrimination complaint, a Complainant should complete a Form (AD-3027), USDA Program Discrimination Complaint Form which can be obtained online at</Trans>: <a href="https://www.usda.gov/sites/default/files/documents/USDA-OASCR%20P-Complaint-Form-0508-0002-508-11-28-17Fax2Mail.pdf" target="_blank">https://www.usda.gov/sites/default/files/documents/USDA-OASCR%20P-Complaint-Form-0508-0002-508-11-28-17Fax2Mail.pdf</a> , <Trans>from any USDA office, by calling (866) 632-9992, or by writing a letter addressed to USDA</Trans>. <Trans>The letter must contain the complainant’s name, address, telephone number, and a written description of the alleged discriminatory action in sufficient detail to inform the Assistant Secretary for Civil Rights (ASCR) about the nature and date of an alleged civil rights violation</Trans>. <Trans>The completed AD-3027 form or letter must be submitted to USDA by</Trans>: </p>
                <span style={{fontWeight:'bolder',color:'black'}}><Trans>(1) mail</Trans>:</span> <p style={{marginLeft:'22px'}}>U.S. <Trans>Department of Agriculture</Trans><br></br> <Trans>Office of the Assistant Secretary for Civil Rights</Trans><br></br> <Trans>1400 Independence Avenue, SW</Trans><br></br> Washington, D.C. 20250-9410; <Trans>or</Trans></p>
                <span style={{fontWeight:'bolder',color:'black'}}> <Trans>(2) fax</Trans>:</span> <p style={{marginLeft:'22px'}}>(833) 256-1665 <Trans>or</Trans> (202) 690-7442; <Trans>or</Trans> </p>
                <span style={{fontWeight:'bolder',color:'black'}}><Trans>(3) email</Trans>: </span><p style={{marginLeft:'22px'}}><a>program.intake@usda.gov.</a></p>
                <p><Trans>This institution is an equal opportunity provider</Trans>.</p>
                <p></p>
              </div>
            </div>
            <div className="col-xs-12">
            <div className="styled-input-container styled-input--rounded">
                <div className="styled-input-single" style={{padding: '0px 0px 0px 33px'}}>
                <input type="checkbox" id="chAccept" checked={this.state.accept} onChange={(e)=>{
                this.setState({accept:e.target.checked?true:false,hasError:(e.target.checked?false:true)})
              }} /> 
              {this.state.programs.isSelected?
                <label htmlFor="chAccept">
                {'I certify* that my household participates in '+this.state.programs.programName}
                </label>:
              <label htmlFor="chAccept">'<Trans>I certify* that the information on this form is correct to the best of my knowledge</Trans>.'</label>
              }

                </div></div>
              
            </div>
            <p style={{fontStyle:'italic'}}>*<Trans>I understand that this information is given in connection with the receipt of Federal funds, and that school officials may verify (check) the information</Trans>. <Trans>I am aware that if I purposely give false information, my children may lose meal benefits</Trans>. <Trans>Deliberate misrepresentation of information may subject applicants to prosecution under applicable State and Federal law</Trans>.</p>
        </div>
        <div className="row">
                <div className="col-md-12 text-center">
                    {
                        this.state.hasError?<span className="text-danger"> <Trans>Please enter all required information above</Trans>.</span>:null
                    }
                </div>
            </div>
        <div className="row">
                <div className="col-md-12">
                    <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(14);
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{ 
                      if(this.state.accept===true){
                        this.props.jumpToStep(16);
                      }
                      else{
                        this.setState({hasError:true});
                      }
                    }}>
                        <Trans>Continue</Trans>
                    </button>
                    <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo} />
               </div>
          </div>
          </div>
        )
    }
}
export default Agreement


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/newLunchApplication/agreement.jsx